import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

export const MoneyValueCell = ({ value }) => (
  <Text.Currency size={11} red={value < 0} value={value} />
)

MoneyValueCell.propTypes = {
  value: PropTypes.number,
}
